import { ActionTree } from 'vuex';
import {
  EAddPageAction,
  EAddPageMutation,
  state as defaultState,
} from '@/dealroom/add-page/store/add-page.constants';
import { IAddPageState } from '@/dealroom/add-page/store/add-page.types';
import { RootState } from '@/store/store';

export const actions: ActionTree<IAddPageState, RootState> = {
  [EAddPageAction.SetDefaultState]({ commit }) {
    commit(EAddPageMutation.SetState, defaultState);
  },
};
